
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"41","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.333 33.228v.833A3.333 3.333 0 0130 37.395H10a3.333 3.333 0 01-3.333-3.334V7.395A3.333 3.333 0 0110 4.06h14.166L30 9.895M13.334 30.728H15","stroke":"#F9BC21","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30.7 16.745a3.501 3.501 0 014.95 4.95l-7.4 7.366-6.584 1.667 1.65-6.583 7.384-7.4z","fill":"#F78E1C","stroke":"#F9BC21","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    